// Installment Modal Functions
window.installmentModal = {
  maxParcelas: 12,
  pixDiscount: 10,
  
  init: function() {
    // Get settings from theme
    const modalElement = document.getElementById('installment-modal');
    if (modalElement) {
      this.maxParcelas = parseInt(modalElement.dataset.maxParcelas) || 12;
      this.pixDiscount = parseInt(modalElement.dataset.pixDiscount) || 10;
    }
  },
  
  open: function(price, maxInstallments) {
    const modal = document.getElementById('installment-modal');
    if (!modal) {
      console.error('Installment modal not found');
      return;
    }
    
    const maxParcelas = this.maxParcelas;
    const pixDiscount = this.pixDiscount;
    
    // Calcular valores
    const pixDiscountAmount = (price * pixDiscount) / 100;
    const pixPrice = price - pixDiscountAmount;
    
    // Atualizar lista de parcelas
    for (let i = 1; i <= maxParcelas; i++) {
      const installmentValue = price / i;
      const item = modal.querySelector(`[data-installment="${i}"]`);
      if (item) {
        const amountSpan = item.querySelector('.installment-amount');
        const totalSpan = item.querySelector('.installment-total');
        
        if (amountSpan) {
          amountSpan.textContent = this.formatMoney(installmentValue);
        }
        if (totalSpan) {
          totalSpan.textContent = this.formatMoney(price);
        }
      }
    }
    
    // Atualizar valores de boleto e PIX
    const boletoPrice = modal.querySelector('.boleto-price');
    if (boletoPrice) {
      boletoPrice.textContent = this.formatMoney(price);
    }
    
    const pixPriceModal = modal.querySelector('.pix-price-modal');
    if (pixPriceModal) {
      pixPriceModal.textContent = this.formatMoney(pixPrice);
    }
    
    // Mostrar modal
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  },
  
  close: function() {
    const modal = document.getElementById('installment-modal');
    if (modal) {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    }
  },
  
  switchTab: function(tabName) {
    // Remover active de todas as tabs
    document.querySelectorAll('.installment-tab').forEach(tab => {
      tab.classList.remove('active');
    });
    document.querySelectorAll('.installment-tab-content').forEach(content => {
      content.classList.remove('active');
    });
    
    // Adicionar active na tab clicada
    const activeTab = document.querySelector(`[data-tab="${tabName}"]`);
    const activeContent = document.getElementById(`tab-${tabName}`);
    
    if (activeTab) activeTab.classList.add('active');
    if (activeContent) activeContent.classList.add('active');
  },
  
  formatMoney: function(cents) {
    const reais = cents / 100;
    return 'R$ ' + reais.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
};

// Funções globais para compatibilidade
function openInstallmentModal(price, maxInstallments) {
  window.installmentModal.open(price, maxInstallments);
}

function closeInstallmentModal() {
  window.installmentModal.close();
}

function switchInstallmentTab(tabName) {
  window.installmentModal.switchTab(tabName);
}

// Inicializar quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.installmentModal.init();
  });
} else {
  window.installmentModal.init();
}

// Fechar modal ao clicar ESC
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    closeInstallmentModal();
  }
});
